import { enqueueSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { SupplyChain } from 'features/globalSetup/types/supplyChain'
import { useMutation } from 'providers/tanstack-query/useMutation'
import { DELETE_SUPPLY_CHAIN } from './api/mutation'
import { Data, Variables } from './api/types'
import { UseDeleteSupplyChain, UseDeleteSupplyChainProps } from './types'

export const useDeleteSupplyChain = ({ name }: UseDeleteSupplyChainProps): UseDeleteSupplyChain => {
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'supplyChain.delete.action',
  })

  const { mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: DELETE_SUPPLY_CHAIN,
    onCompleted: async (data: Data): Promise<void> => {
      const { errors } = data

      if (errors && errors.length > 0) {
        enqueueSnackbar(t('error', { supplyChain: name }), { variant: 'error' })
      } else {
        enqueueSnackbar(t('success', { supplyChain: name }), { variant: 'success' })
      }
    },
    queriesToInvalidate: ['supplyChains'],
  })

  const deleteSupplyChain = (id: SupplyChain['id']): void => {
    mutateAsync({ input: { id } })
  }

  return {
    deleteSupplyChain,
  }
}
